import { client } from '.';
import {
  AccountStatusWithLocations,
  GetNestedLocationByIdResponse,
  NestedLocation,
  NestedLocationParams,
  NestedLocationPayload,
  NestedLocationResponse,
  PaginatedNestedLocationsParams,
  PaginatedNestedLocationsResponse,
} from '../types/nestedLocations';

const getNestedLocations = async (params: NestedLocationParams = {}) => {
  const response = await client.get<NestedLocationResponse>('/nestable_locations', { params });
  return response.data;
};

const getAllLocations = async () => {
  const response = await client.get<NestedLocation[]>('/nestable_locations/all_locations');
  return response.data;
};

const getPaginatedLocations = async (params: PaginatedNestedLocationsParams = {}) => {
  const response = await client.get<PaginatedNestedLocationsResponse>(
    '/nestable_locations/paginated_locations',
    { params },
  );
  return response.data;
};

const checkAccountStatusWithLocations = async () => {
  const response = await client.get<AccountStatusWithLocations>(
    '/nestable_locations/check_account_locations',
  );
  return response.data;
};

const deleteNestedLocations = async (locationId: number) => {
  const response = await client.delete<string>(`/nestable_locations/${locationId}`);
  return response.data;
};

const createNestedLocation = async (data: NestedLocationPayload) => {
  const response = await client.post<NestedLocationResponse>('/nestable_locations', data);
  return response.data;
};

const updateNestedLocation = async (locationId: number, data: Partial<NestedLocationPayload>) => {
  const response = await client.put<NestedLocationResponse>(
    `/nestable_locations/${locationId}`,
    data,
  );
  return response.data;
};

export const exportNestedLocations = async (locationsIds: number[] = []) => {
  return client.get('/nestable_locations/export', {
    params: locationsIds.length ? { ids: locationsIds.join(',') } : undefined,
  });
};

const importNestedLocations = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await client.post<{ message: string; error?: string }>(
    '/nestable_locations/import',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      },
    },
  );
  return response.data;
};

const exportNestedLocationsTemplate = async () => {
  const response = await client.get<{ download_url: string; filename?: string }>(
    '/nestable_locations/export_template',
  );
  return response.data;
};

const exportLegacyLocations = async () => {
  const response = await client.get<Blob>('/locations.xlsx', { responseType: 'blob' });
  return new Blob([response.data]);
};

const getNestedLocationById = async (id: number) => {
  const response = await client.get<GetNestedLocationByIdResponse>(`/nestable_locations/${id}`);
  return response.data;
};

export const nestedLocationsApi = {
  getNestedLocations,
  getNestedLocationById,
  getAllLocations,
  getPaginatedLocations,
  checkAccountStatusWithLocations,
  deleteNestedLocations,
  createNestedLocation,
  updateNestedLocation,
  exportNestedLocations,
  importNestedLocations,
  exportNestedLocationsTemplate,
  exportLegacyLocations,
};
